import React from 'react';
import { useSetAtom } from 'jotai';
import { navigateAtom } from '../../../../atoms/v3/navigationAtoms';
import { newConverstaionMessageBufferAtom } from '../../../../atoms/v3/chatAtoms';

/**
 * 新建聊天按钮组件
 * 显示为一个加号图标
 * 内部直接实现点击逻辑，不需要外部传入
 */
export const NewChatButton: React.FC = () => {
  const navigate = useSetAtom(navigateAtom);
  const cleanNewBuffer = useSetAtom(newConverstaionMessageBufferAtom)

  // 处理新建聊天按钮点击
  const handleNewChat = () => {
    // 直接导航到新建聊天页面
    cleanNewBuffer([])
    navigate({ path: '/v3/chat-detail/new', replace: true });
  };

  return (
    <button
      onClick={handleNewChat}
      className="p-2 rounded-full text-ios-blue dark:text-ios-dark-blue hover:opacity-70 transition-opacity"
      aria-label="新建聊天"
    >
      <svg
        className="w-5 h-5"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5 2.5C18.8978 2.10217 19.4374 1.87868 20 1.87868C20.5626 1.87868 21.1022 2.10217 21.5 2.5C21.8978 2.89782 22.1213 3.43739 22.1213 4C22.1213 4.56261 21.8978 5.10217 21.5 5.5L12 15L8 16L9 12L18.5 2.5Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};
